/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';
import { KEY_DOWN, KEY_END, KEY_ENTER, KEY_HOME, KEY_LEFT, KEY_RIGHT, KEY_UP } from '@gh/core-ui';
import { includes } from 'lodash';
import { AbstractGridInputCellEditorComponent } from './abstract-grid-input-cell-editor.component';

const STOPPED_KEYS = [KEY_UP, KEY_DOWN, KEY_LEFT, KEY_RIGHT, KEY_HOME, KEY_END];

@Component({
  selector: 'gh-grid-textarea-cell-editor',
  template: require('./grid-textarea-cell-editor.component.html'),
  styles: [require('./grid-input-cell-editor.component.scss'), require('./grid-textarea-cell-editor.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridTextareaCellEditorComponent extends AbstractGridInputCellEditorComponent {
  isPopup(): boolean {
    return true;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.keyCode === KEY_ENTER && !event.ctrlKey || includes(STOPPED_KEYS, event.keyCode)) {
      event.stopPropagation();
    }

    // complete editing on Ctrl + Enter
    // we have to prevent default behavior, because otherwise editing is started again
    if (event.keyCode === KEY_ENTER && event.ctrlKey) {
      event.preventDefault();
    }
  }
}
